import { Menu } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ContextMenuMeasurements = ({ onGetMenuItems, onSetLabel, onClose, onDelete }) => {
  const { t } = useTranslation('ViewerTool');
  const defaultMenuItems = [
    {
      label: 'Delete measurement',
      actionType: 'Delete',
      action: (item) => {
        onDelete(item);
        onClose();
      },
      value: {},
    },
    {
      label: 'Set Label',
      actionType: 'setLabel',
      action: (item) => {
        onSetLabel(item);
        onClose();
      },
      value: {},
    },
  ];

  const menuItems = onGetMenuItems(defaultMenuItems).map((it) => ({
    label: t(it.label),
    onClick: () => it.action(it),
  }));

  if (!menuItems.length) return;
  return (
    <Menu
      className="popup border-background-light-5 bg-background-light-5 text-black dark:border-background-dark-5 dark:bg-background-dark-5 dark:text-white"
      items={menuItems}
      mode="vertical"
    />
  );
};

ContextMenuMeasurements.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSetLabel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onGetMenuItems: PropTypes.func.isRequired,
};

export default ContextMenuMeasurements;
